var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"v-badge",class:{
    success: _vm.theme == 'success',
    primary: _vm.theme == 'primary',
    danger: _vm.theme == 'danger',
  }},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }